<template>
  <basic-container v-loading="pageLoading">
    <!-- 列表 -->
    <avue-form
      ref="searchForm"
      v-model="searchForm"
      :option="searchFromOption"
      @reset-change="searchClear"
    >
      <template slot="menuForm">
        <div class="fr">
          <el-button size="small" type="primary" @click="searchSubmit()">
            搜索
          </el-button>
          <el-button size="small" @click="searchClear()">重置</el-button>
        </div>
      </template>

      <template slot-scope="" slot="outboundTime">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['12:00:00']"
        >
        </el-date-picker>
      </template>
    </avue-form>
    <avue-crud
      :option="crudOption"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      @search-change="searchChange"
      @current-change="currentChange"
      @size-change="sizeChange"
    >
      <template slot="menuLeft">
      
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-if="scope.row.outboundStatus == 2"
          type="text"
          size="small"
          @click="detailDialogOpen(scope.row)"
          >详情</el-button
        >
        <el-button
          v-if="scope.row.outboundStatus == 1 && scope.row.type == 2"
          type="text"
          size="small"
          @click="detailDialogOpen(scope.row, '入库')"
          >入库</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="scope.row.inboundStatus === '2'"
          >打印出库单</el-button
        >
      </template>
    </avue-crud>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="isInbound ? '入库' : '详情'"
      :visible.sync="addDialogVisible"
      append-to-body
      width="80%"
      @close="addDialogColse"
    >
      <div v-if="addDialogVisible">
        <avue-form ref="addForm" v-model="addForm" :option="addFormOption">
          <template slot="requisitionDept">
            <div style="width: 100%; flex: 1" v-if="mode === 'add'">
              <el-select
                style="width: 100%"
                v-model="addForm.requisitionDept"
                :value="addForm.requisitionDept"
                placeholder="请选择服务地点"
                clearable
                ref="addConnectSelect"
                @change="requisitionDeptChange"
              >
                <el-option
                  :value="addForm.requisitionDept"
                  show-all-levels
                  :label="addForm.requisitionDeptName"
                >
                  <el-tree
                    node-key="id"
                    :data="warehouseDeptList"
                    :props="treeProps"
                    @node-click="requisitionDeptNodeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </div>
            <div style="width: 100%; flex: 1" v-else>
              <el-input
                style="width: 100%"
                v-model="addForm.requisitionDeptName"
                disabled
              />
            </div>
          </template>

          <template slot="projectId">
            <div style="width: 100%; flex: 1" v-if="mode == 'add'">
              <el-select
                style="width: 100%"
                @change="projectIdChange"
                v-model="addForm.projectId"
                :value="addForm.projectId"
                clearable
              >
                <el-option
                  v-for="item in prjectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div style="width: 100%; flex: 1" v-else>
              <el-input
                style="width: 100%"
                v-model="addForm.projectName"
                disabled
              />
            </div>
          </template>
          <template slot="requisitionUser">
            <div style="width: 100%; flex: 1" v-if="mode == 'add'">
              <el-select
                style="width: 100%"
                v-model="addForm.requisitionUser"
                :value="addForm.requisitionUser"
                placeholder="请选择领用人"
                clearable
              >
                <el-option
                  v-for="item in warehouseOutboundUserList"
                  :key="item.id"
                  :label="item.realNameAndPhone"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div style="width: 100%; flex: 1" v-else>
              <el-input
                style="width: 100%"
                v-model="addForm.requisitionUserName"
                disabled
              />
            </div>
          </template>
        </avue-form>
        <!--  csColumns  csNumKey  csPriceKey 都有默认值,可以不传-->
        <ConsumableSelector
          ref="cs"
          :columns="csColumns"
          :numberKey="csNumKey"
          :priceKey="csPriceKey"
          :data.sync="csData"
          :projectId="searchForm.projectId"
          @loadData="loadData"
          @loadPrice="loadPrice"
          :editable="mode !== 'view'"
          :scene="csScene"
          :showSum="true"
          :priceMode="priceMode"
          :numberMode="numberMode"
        />
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <el-button
            v-if="mode != 'view'"
            type="primary"
            size="small"
            @click="submit(2)"
            style="margin-right: 20px"
            >提交</el-button
          >
          <el-button
            v-if="isInbound"
            type="primary"
            size="small"
            style="margin-right: 20px"
            @click="inBoundAllotSubmit(2)"
          >
            提交
          </el-button>
          <el-button size="small" @click="closeAddDialog">返回</el-button>
        </div>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { allotInboundAction } from "@/api/warehouse-allot/warehouse-allot";
import {
  outboundSummary,
  outboundConsumableList,
  getUserListByDept,
  treeByProjectDeptId,
  outboundDetail,
  outboundSave,
  getOutboundList,
} from "@/api/crmedical/warehouse/outwarehouse.js";
import {
  getWarehouseList,
  getDict,
  getBusinessNo,
  inboundDetailList,
} from "@/api/crmedical/warehouse/index.js";

import {
  getProjectUserList,
  consumableCalculate,
} from "@/api/crmedical/requisition/index.js";
import ConsumableSelector from "@/components/consumable-selector/index";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  props: ["allotNo", "searchForm12", "allotRow"],
  components: { ConsumableSelector },
  computed: {
    ...mapGetters(["userInfo"]),
    searchFromOption() {
      return {
        size: "small",
        submitBtn: false,
        emptyBtn: false,
        menuSpan: 24,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            span: 6,
            clearable: false,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.prjectList,
            disabled: true,
          },
          {
            label: "调出仓库",
            prop: "warehouseId",
            type: "select",
            span: 6,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList,
            disabled: true,
          },
          {
            label: "出库类型",
            prop: "type",
            type: "select",
            display: false,
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: this.warehouseInboundTypeList,
          },
          {
            label: "确认状态",
            prop: "outboundStatus",
            type: "select",
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: this.inboundStatusList,
          },
          {
            label: "出库单号",
            prop: "outboundNo",
            span: 6,
          },
          {
            label: "出库时间",
            prop: "outboundTime",
            formslot: true,
            span: 6,
          },
          {
            label: "申请人",
            prop: "applyUserName",
            span: 6,
            disabled: true,
          },
          {
            label: "汇总金额",
            prop: "outboundAmount",
            span: 6,
            disabled: true,
          },
          {
            label: "调拨单号",
            prop: "linkNo",
            type: "input",
            span: 6,
            disabled: true,
          },
        ],
      };
    },
    addFormOption() {
      return {
        size: "small",
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            clearable: false,
            span: 6,
            props: {
              label: "name",
              value: "id",
            },
            formslot: true,
            dicData: this.prjectList,
            rules: [{ required: true, message: "请选择项目名称" }],
            disabled: this.mode !== "add",
          },
          { label: "仓库名称", prop: "destWarehouseName", disabled: true },
          {
            label: "出库号",
            prop: "outboundNo",
            span: 6,
            disabled: true,
            rules: [{ required: true, message: "请选择出库号" }],
          },
          {
            label: "关联单号",
            prop: "linkNo",
            span: 6,
            disabled: this.mode == "view",
            display: this.mode == "view",
          },
          {
            label: "备注",
            prop: "remark",
            span: 12,
            maxlength: 50,
            disabled: !this.isInbound,
          },
        ],
      };
    },
    crudOption() {
      return {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "项目名称",
            prop: "projectName",
          },
          {
            label: "出库单号",
            prop: "outboundNo",
          },
          {
            label: "调拨单号",
            prop: "linkNo",
          },

          {
            label: "调入仓库",
            prop: "destWarehouseName",
          },
          {
            label: "调出仓库",
            prop: "originWarehouseName",
          },
          {
            label: "出库人",
            prop: "outboundUserName",
          },
          {
            label: "出库时间",
            prop: "outboundTime",
          },
          {
            label: "出库金额",
            prop: "outboundAmount",
          },
          {
            label: "确认人",
            prop: "confirmUserName",
          },
          {
            label: "确认状态",
            prop: "outboundStatus",
            type: "select",
            clearable: false,
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: this.inboundStatusList,
            rules: [{ required: true, message: "请选择仓库" }],
          },
        ],
      };
    },
  },
  data() {
    return {
      project: { id: "", name: "" },
      destWarehouse: { id: "", name: "" },
      originWarehouse: { id: "", name: "" },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 40, 50, 100],
        layout: "total,pager,prev, next",
        background: false,
      },
      isInbound: false,
      timeRange: "",
      requisitionUserLoading: false,
      requisitionUserList: [],
      numberMode: "input",
      priceMode: "dynamic",
      editable: true,
      showSum: true,
      deptList: [],
      warehouseOutboundUserList: [],
      treeProps: {
        //标题
        label: "title",
        //值
        value: "id",
        //子节点
        children: "children",
        //是否叶子节点
        isLeaf: "hasChildren",
        //本节点类型key值
        objectType: "id",
        //本节点类型名
        objectTypeName: "title",
      },
      pageLoading: false,
      prjectList: [],
      warehouseList: [],
      warehouseDeptList: [],
      warehouseInboundTypeList: [],
      inboundStatusList: [],
      dicts: {},
      mode: "", //add,view,edit
      searchForm: {
        value1: "",
        projectId: "",
        warehouseId: "",
        type: "",
        outboundStatus: "",
        outboundNo: "",
        linkNo: "",
        applyUserName: "",
      },
      addForm: {
        requisitionDeptName: "",
        projectId: "",
        warehouseId: "",
        type: "",
        inboundStatus: "",
        outboundNo: "",
        enterUserName: "",
        enterTime: "",
        submitUserName: "",
        submitTime: "",
        cancelUserName: "",
        cancelTime: "",
        outboundNo: "",
      },
      addDialogVisible: false,
      data: [], //出库单列表
      csData: [],
      //展示表格列配置
      csNumKey: "outboundNum",
      csColumns: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "类型", prop: "typeName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "计量单位", prop: "measuringUnitName" },
        { label: "入库单价", prop: "price" },
        { label: "入库数量", prop: "outboundNum" },
        { label: "入库小计", prop: "rowSum" },
        // { label: "库存数量", prop: "stockNum"},
        {
          label: "剩余可数量领用",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
    };
  },
  created() {
    console.log("props this.allotNo=====>", this.allotNo);
    console.log("props this.allotRow==>", this.allotRow);
    this.destWarehouse = {
      id: this.allotRow.destWarehouseId,
      name: this.allotRow.destWarehouseName,
    };
    this.originWarehouse = {
      id: this.allotRow.originWarehouseId,
      name: this.allotRow.originWarehouseName,
    };
    this.project = {
      id: this.allotRow.projectId,
      name: this.allotRow.$projectId,
    };
    //项目
    this.prjectList = [this.project];
    this.searchForm.projectId = this.allotRow.projectId;
    //仓库
    this.warehouseList = [this.originWarehouse];
    this.searchForm.warehouseId = this.allotRow.originWarehouseId;
    //申请人
    this.searchForm.applyUserName = this.allotRow.applyUserName;
    //调拨单号
    this.searchForm.linkNo = this.allotNo;
    console.log("this.searchForm==>", this.searchForm);
    //
    this.searchForm.type = 2;
    this.fetchData();
    outboundSummary(this.searchForm).then((res) => {
      this.searchForm.outboundAmount =
        JSON.stringify(res.data) === "{}" ? "" : res.data;
    });
  },
  methods: {
    // 获取表单搜索条件
    setSearchForm(form) {
      console.log("ceshisiahdiahsdahdjkasd");
      console.log(form);
      this.searchForm = form;
    },
    async inBoundAllotSubmit() {
      let inBoundForm = {};
      let no = await getBusinessNo({ businessType: 1 });
      inBoundForm.inboundNo = no.data;
      inBoundForm.linkId = this.addForm.id;
      inBoundForm.linkNo = this.addForm.linkNo;
      inBoundForm.remark = this.addForm.remark;
      console.log(inBoundForm);
      //   return;
      allotInboundAction(inBoundForm)
        .then((res) => {
          this.pageLoading = false;
          this.$message.success(res.msg);
          this.addDialogVisible = false;
          this.loadList();
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    closeAddDialog() {
      this.addDialogVisible = false;
    },
    projectIdChange(val) {
      this.addForm = Object.assign({}, this.addForm, {
        warehouseId: "",
        projectId: val,
      });
      this.csData = [];

      getWarehouseList({
        projectId: this.addForm.projectId,
      }).then(({ data }) => {
        // setTimeout(()=>{
        // console.log(this.addFormOption.column[1].dicData);
        // this.addFormOption.column[1].dicData = data;
        this.warehouseList = data;
        this.addForm.warehouseId = this.warehouseList[0]
          ? this.warehouseList[0].id
          : "";

        treeByProjectDeptId({ projectId: this.addForm.projectId }).then(
          (res) => {
            this.addForm = Object.assign({}, this.addForm, {
              requisitionDept: "",
              requisitionDeptName: "",
            });
            this.warehouseDeptList = res.data;
          }
        );
        // })
      });
    },
    warehouseChange(val) {
      if (val) {
        this.csData = [];
        this.addForm = Object.assign({}, this.addForm, {
          warehouseId: val,
        });
      }
    },
    //人员搜索
    remoteMethod(val) {
      const params = {
        projectId: this.searchForm.projectId,
        realNameAndPhone: val,
      };
      this.requisitionUserLoading = true;
      getProjectUserList(params).then((res) => {
        this.requisitionUserLoading = false;
        console.log("res==>", res);
        this.requisitionUserList = res.data;
      });
    },
    requisitionDeptNodeClick(node) {
      // console.log(data);

      setTimeout(() => {
        if (node.hasChildren) {
          // this.$message.error();
          return;
        }
        console.log(node.hasChildren);
        this.addForm = Object.assign({}, this.addForm, {
          requisitionDept: node.id,
          requisitionDeptName: node.title,
        });
        this.addForm = Object.assign({}, this.addForm, {
          requisitionUser: "",
        });
        getUserListByDept({ deptId: node.id }).then((res) => {
          console.log(res);
          this.warehouseOutboundUserList = res.data;
        });
        this.$refs.addConnectSelect.blur();
      });
    },
    addDialogColse() {
      this.$refs.addForm.linkNo = "";
      this.$refs.addForm.supplier = "";
      this.$refs.addForm.remark = "";
    },

    getDeptList() {
      treeByProjectDeptId({ projectId: this.searchForm.projectId }).then(
        ({ data }) => {
          let list = [];
          function searchChildren(data) {
            data.forEach((ele) => {
              list.push(ele);
              if (ele.children && ele.children.length > 0) {
                searchChildren(ele.children);
              }
            });
          }
          searchChildren(data);
          this.deptList = list;
          console.log("this.deptList=====>", this.deptList);
          this.deptList.forEach((element) => {
            if (this.addForm.requisitionDept === element.id) {
              console.log(this.addForm.requisitionDept);
              // this.addForm.requisitionDeptName = element.title;
              this.addForm = Object.assign({}, this.addForm, {
                requisitionDeptName: element.title,
              });
            }
          });

          this.warehouseList.forEach((element) => {
            if (this.addForm.warehouseId === element.id) {
              console.log(this.addForm.warehouseId);
              // this.addForm.requisitionDeptName = element.title;
              this.addForm = Object.assign({}, this.addForm, {
                warehouseName: element.name,
              });
            }
          });

          this.prjectList.forEach((element) => {
            if (this.addForm.projectId === element.id) {
              console.log(this.addForm.projectId);
              // this.addForm.requisitionDeptName = element.title;
              this.addForm = Object.assign({}, this.addForm, {
                projectName: element.name,
              });
            }
          });
          console.log(this.addForm.projectName, this.addForm.projectId);
        }
      );
    },
    async detailDialogOpen(row, type) {
      let res1 = await outboundDetail({ id: row.id });
      res1.data.inboundStatus = res1.data.inboundStatus + ""; //字典值 数字转字符
      res1.data.type = res1.data.type + ""; //字典值 数字转字符
      let res2 = await inboundDetailList({ inboundId: row.id });
      res2.data.forEach((ele) => {
        ele.id = ""; //处理id默认-1的bug
      });
      this.mode = row.inboundStatus == 1 ? "edit" : "view";
      this.addForm = res1.data;
      this.csData = res1.data.consumableList;
      this.numberMode = "normal";
      this.priceMode = "normal";
      this.editable = false;
      this.showSum = false;
      if (type == "入库") {
        this.addForm.remark = "";
        this.isInbound = true;
      } else {
        this.isInbound = false;
      }
      this.addForm.destWarehouseName = row.destWarehouseName;
      this.addDialogVisible = true;
      this.getDeptList();
    },
    searchClear() {
      this.timeRange = "";
      this.searchForm.beginTime = "";
      this.searchForm.endTime = "";
      this.searchForm.outboundStatus = "";
      this.searchForm.outboundNo = "";
      this.loadList();
    },
    searchSubmit() {
      console.log(this.timeRange);
      if (!this.timeRange) {
        this.searchForm.beginTime = "";
        this.searchForm.endTime = "";
      } else {
        this.searchForm.beginTime = dayjs(this.timeRange[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.searchForm.endTime = dayjs(this.timeRange[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      // this.searchForm.outboundAmount = "";
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    sizeChange() {
      this.loadList();
    },
    async submit(type) {
      let valid_ = true;
      await this.$refs.addForm.validate((valid, done, msg) => {
        valid_ = valid;
        done();
      });
      if (!valid_) {
        return;
      }
      this.addForm.enterTime = dayjs(this.addForm.enterTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.addForm.submitTime = dayjs(this.addForm.submitTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.addForm.cancelTime = dayjs(this.addForm.cancelTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.addForm.outboundStatus = type;
      if (this.csData.length == 0 && type == 2) {
        this.$message.error("提交时请至少选择一个货品");
        return;
      } else {
        // this.addForm.inboundConsumableList = this.csData;
        this.addForm.consumableList = this.csData;
      }
      let vali = this.$refs.cs.validate();
      console.log("vali==>", vali);
      if (vali) {
        this.$confirm("是否提交", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.pageLoading = true;
            console.log("this.addForm==>", this.addForm);
            outboundSave(this.addForm)
              .then((res) => {
                this.pageLoading = false;
                this.$message.success(res.msg);
                this.addDialogVisible = false;
                this.loadList();
              })
              .catch(() => {
                this.pageLoading = false;
                // this.$message.success(res.msg);
                // this.addDialogVisible = false;
                // this.loadList();
                // this.$message({
                //   type: "info",
                //   message: "已取消",
                // });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    loadData(query, resolve) {
      query.searchName = query.text;
      const params = {
        ...query,
        projectId: this.addForm.projectId,
        warehouseId: this.addForm.warehouseId,
      };
      outboundConsumableList(params).then((res) => {
        // res.data.records.forEach((element) => {
        console.log(res.data.records);

        res.data.records.forEach((element) => {
          element.id = "";
          element.name = element.consumableName;
          element.outboundNo = 0;
        });
        // res.data = {
        //   records: res.data
        // }
        resolve(res.data);
      });
    },
    loadPrice(query, resolve) {
      // setTimeout(() => {
      const params = {
        ...query,
        warehouseId: this.addForm.warehouseId,
      };
      consumableCalculate(params).then((res) => {
        console.log("res consumableCalculate==>", res);
        resolve(res.data);
      });
      // }, 500);
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        //type && status
        const dicts = await Promise.all([
          getDict({ code: "warehouse_outbound_type" }),
          getDict({ code: "warehouse_outbound_status" }),
        ]);
        this.warehouseInboundTypeList = dicts[0].data;
        // this.searchForm.type = this.warehouseInboundTypeList[0].dictKey;
        this.searchForm.type = 2;
        this.inboundStatusList = dicts[1].data;
        this.searchForm.inboundStatus = this.inboundStatusList[0].dictKey;
        //load list
        this.loadList();
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    loadList() {
      this.pageLoading = true;
      this.searchForm.current = this.page.currentPage;
      this.searchForm.pageSize = this.page.pageSize;
      getOutboundList(this.searchForm)
        .then((res) => {
          this.pageLoading = false;
          res.data.records.forEach((ele) => {
            // ele.inboundStatus += "";
            ele.outboundStatus += "";
            ele.type += "";
            ele.linkNo = this.allotNo;
            ele.originWarehouseName = this.originWarehouse.name;
            ele.destWarehouseName = this.destWarehouse.name;
            ele.projectName = this.project.name;
          });
          this.data = res.data.records;
          this.page.currentPage = res.data.current;
          this.page.total = res.data.total;
          this.page.pageSize = res.data.pageSize;
        })
        .catch((err) => {
          console.log("err==>", err);
          this.pageLoading = false;
        });
      outboundSummary(this.searchForm).then((res) => {
        this.searchForm.outboundAmount =
          JSON.stringify(res.data) === "{}" ? "0" : res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
</style>